import script from "./CardAddUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardAddUser.vue?vue&type=script&setup=true&lang=ts"

import "./CardAddUser.vue?vue&type=style&index=0&id=a3b6a672&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3b6a672"]])

export default __exports__